import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Info } from '../../public-api';
import { AbstractService } from '../commons/abstract.service';

@Injectable({ providedIn: 'root' })
export class InfoService extends AbstractService<Info> {

  getURLBase(): string {
    return '/info';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Info): void {
    delete obj?._id;
  }
  preUpdate(obj: Info): void {
  }

}  